import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector, accountIdSelector } from '../../../data/global/dataSelectors';
import { Actions } from '../../../data/global/actions';
import { AccountSettings, DashboardSettingsPath, UiSettings } from '@tradingblock/types';
import { InitialState } from '../../../data/global/initialState';
import { useStore } from '../../../context/Storage';
import { DataState } from '../../../data/global/state';
import { createSelector } from 'reselect';
import { useBlockId } from '../../blocks/BlockState';
import { blockSettings } from '../../../data/global/selectors/settingSelectors';
import { SettingsFields } from '../../form/GenericField';

const accountInfoSelector = createSelector(
  accountIdSelector,
  (s: DataState) => s.settings.ui.loaded,
  (accountId, loaded) => ({ accountId, loaded })
);

export const AccountSettingsFields: SettingsFields<AccountSettings> = {
  showRefresh: {
    type: 'boolean',
    label: 'Show refresh button'
  }
};

export const useAccountSettings = () => {
  const dispatch = useDispatch();
  const { accountId, loaded } = useStateSelector(accountInfoSelector);
  const storage = useStore();
  useEffect(() => {
    const getSettings = async (id: number) => {
      dispatch(Actions.requestSettings({ accountId: id }));
      const settings = await storage.get<UiSettings>(DashboardSettingsPath);
      dispatch(Actions.receiveSettings({ accountId: id, settings: settings || { ...InitialState.settings.ui } }));
    };
    if (accountId && loaded !== true) getSettings(accountId);
  }, [loaded, accountId]);

  const blockId = useBlockId();
  //@ts-ignore
  const current = useStateSelector(s => blockSettings.account(s, blockId));
  return {
    current: current || { showRefresh: false },
    definitions: AccountSettingsFields,
  };
};

export const useAccountSettingsValue = () => {
  const { current } = useAccountSettings();
  return current;
};
